import { Button, LoadingButton } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { acceptAllParticipantFeedback } from "services/survey";
import { toastMessage } from "utils/toastMessageHelper";

const AcceptAllSurvey = ({
  handleClose,
  surveyId,
  participantFeedbackList,
}) => {
  const { t } = useTranslation();
  // Set all value
  const [buttonLoader, setButtonLoader] = useState(false);

  // Function handler
  // Accept All Participant feedback

  const acceptAllParticipantFeedbackHandler = async (file) => {
    try {
      setButtonLoader(true);
      const reqData = {
        surveyId: surveyId,
        token: getFromLocal() || "",
      };
      const responseData = await acceptAllParticipantFeedback(reqData);
      const { message = "", status: requstStatus } = responseData;
      if (requstStatus === 200) {
        handleClose();
        toastMessage(message, "success", "acceptAllParticipantFeedback");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setButtonLoader(false);
      handleClose();
    }
  };

  return (
    <div>
      <h2>{t("PARTICIPANT_FEEDBACK.acceptAllParticipantFeedback")}</h2>
      <p>{t("PARTICIPANT_FEEDBACK.sureAcceptAllParticipantFeedback")}</p>
      <div className="button_wrap">
        <LoadingButton
          className="light"
          onClick={acceptAllParticipantFeedbackHandler}
          loading={buttonLoader}
        >
          {t("COMMON.yes")}
        </LoadingButton>
        <Button onClick={handleClose}>{t("COMMON.yes")}</Button>
      </div>
    </div>
  );
};

export default AcceptAllSurvey;
